import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PendingRequestsService {
  private cancelPendingRequests$ = new Subject<void>();
  private readonly _bypassInstantNavigation = signal(false);
  public readonly canBypass = this._bypassInstantNavigation.asReadonly();

  public getCancelSignal() {
    return this.cancelPendingRequests$.asObservable();
  }

  public cancelPendingRequests() {
    this.cancelPendingRequests$.next();
  }

  public setCanBypassCancelation(bypass: boolean) {
    this._bypassInstantNavigation.set(bypass);
  }
}
